import React, { Component, Fragment } from "react";
import { Link, withRouter } from "react-router-dom";
import { Nav, Navbar, NavItem } from "react-bootstrap";
import "./App.css";
import Routes from "./Routes";
import { LinkContainer } from "react-router-bootstrap";
import { Auth } from "aws-amplify";
import config from "./config";
import { ToastContainer, toast } from "react-toastify";
import ReactModal from "react-modal";
import "react-toastify/dist/ReactToastify.css";

ReactModal.setAppElement("#root");

class App extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isAuthenticated: false,
      isAuthenticating: true
    };
  }

  async componentDidMount() {
    this.loadFacebookSDK();
    await Auth.currentAuthenticatedUser()
      .then(res => {
        this.userHasAuthenticated(true);
        console.log("current user info: \n", res);

        Auth.currentUserCredentials()
          .then(ses => {
            console.log("current user session: \n", ses);
            if (!ses.authenticated) {
              this.userHasAuthenticated(false);
            }
          })
          .catch(err => {
            console.log("currentUserCredentials Error:", err);
            if (err === "No current user") {
              this.userHasAuthenticated(false);
            }
          });
      })
      .catch(err => {
        console.log("App.DidMount:", err);
        if (err === "not authenticated") {
          this.userHasAuthenticated(false);
          //this.props.history.push("/");
        }
      });
    this.setState({ isAuthenticating: false });
  }

  loadFacebookSDK() {
    console.log("FB Check");
    window.fbAsyncInit = function() {
      window.FB.init({
        appId: config.social.FACEBOOK_APPID,
        autoLogAppEvents: true,
        xfbml: true,
        cookie: true, // enable cookies to allow the server to access the session
        version: "v2.8"
      });
    };

    (function(d, s, id) {
      var js,
        fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) {
        return;
      }
      js = d.createElement(s);
      js.id = id;
      js.src = "https://connect.facebook.net/en_US/sdk.js";
      fjs.parentNode.insertBefore(js, fjs);
    })(document, "script", "facebook-jssdk");
  }

  userHasAuthenticated = async authenticated => {
    if (!this.userHasAuthenticated) {
      await Auth.signOut();
      localStorage.clear();
    }
    this.setState({ isAuthenticated: authenticated });
  };

  handleLogout = async event => {
    this.userHasAuthenticated(false);
    try {
      if (await Auth.currentSession()) {
        Auth.signOut()
          .then(data => console.log(data))
          .catch(err => console.log(err));
        this.userHasAuthenticated(false);
      }
    } catch (e) {
      if (e !== "No current user") {
        toast.error(e);
      }
    }
    this.props.history.push("/");
  };

  render() {
    const childProps = {
      isAuthenticated: this.state.isAuthenticated,
      userHasAuthenticated: this.userHasAuthenticated
    };

    return (
      !this.state.isAuthenticating && (
        <div className="App">
          <Navbar collapseOnSelect={true}>
            <Navbar.Header>
              <Navbar.Brand>
                <Link to="/">Bukhu</Link>
              </Navbar.Brand>
              <Navbar.Toggle />
            </Navbar.Header>
            <Navbar.Collapse>
              <Nav pullRight>
                {this.state.isAuthenticated ? (
                  <Fragment>
                    <LinkContainer to="/library">
                      <NavItem>Library</NavItem>
                    </LinkContainer>
                    <LinkContainer to="/user">
                      <NavItem>Profile</NavItem>
                    </LinkContainer>
                    <LinkContainer to="/friends">
                      <NavItem>Friends</NavItem>
                    </LinkContainer>
                    <LinkContainer to="/signup">
                      <NavItem>Signup</NavItem>
                    </LinkContainer>
                    <NavItem onClick={this.handleLogout}>Logout</NavItem>
                  </Fragment>
                ) : (
                  <Fragment>
                    <LinkContainer to="/login">
                      <NavItem>Login</NavItem>
                    </LinkContainer>
                    <LinkContainer to="/signup">
                      <NavItem>Signup</NavItem>
                    </LinkContainer>
                  </Fragment>
                )}
                <Fragment>
                  <LinkContainer to="/PrivacyPolicy">
                    <NavItem>Privacy Policy</NavItem>
                  </LinkContainer>
                  <LinkContainer to="/Terms">
                    <NavItem>Terms</NavItem>
                  </LinkContainer>
                </Fragment>
              </Nav>
            </Navbar.Collapse>
          </Navbar>
          <Routes childProps={childProps} />

          <div className="navbar-fixed-bottom navbar-default">
            © 2019 BukHu.com
          </div>
          <ToastContainer
            autoClose={8000}
            position={toast.POSITION.TOP_RIGHT}
          />
        </div>
      )
    );
  }
}

export default withRouter(App);



// WEBPACK FOOTER //
// ./src/App.js